<div *ngIf="pageVersion" class="product-options">
    <app-product-info [productInfoTitle]="title"></app-product-info>
    <div class="product-reasons-grid">
        <app-product-option *ngFor="let card of cards" [card]="card"></app-product-option>
    </div>
</div>